import { render } from "./AppTopbar.vue?vue&type=template&id=61146766"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Trabalho\\Projetos\\Sistemas\\Front\\app-base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__